var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { INJECT_UICORE_BUS } from "../../../lib/utils/consts";
import { Prop } from 'vue-property-decorator';
import { pull } from "lodash-es";
import { delay } from "../../../lib/utils";
/** 多开类似使用.show(opt)启动的UICore弹窗
 * .show返回的promise完成时意味着窗口关闭
 * */
let UcWindowManager = class UcWindowManager extends Vue {
  constructor() {
    super(...arguments);
    this.optList = [];
    this.showedIdSet = new Set();
    this.rerenderCount = 0;
  }
  clear() {
    this.showedIdSet.clear();
    this.optList.length = 0;
  }
  render() {
    const h = arguments[0];
    // optList 元素替换时由rerenderCount通知依赖
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    this.rerenderCount;
    const getRefKey = opt => `ref_${opt.id}`;
    const WindowComponent = this.component;
    // @ts-ignore ignore vue组件jsx报错
    const renderOpt = this.optList.map(optItem => h(WindowComponent, {
      "key": optItem.id,
      "ref": getRefKey(optItem)
    }));
    // comp初始化之后走一次show的逻辑
    this.optList.forEach(optItem => {
      const optId = optItem.id;
      // 如果没走过show逻辑的这里统一走一次
      if (!this.showedIdSet.has(optId)) {
        this.showedIdSet.add(optId);
        this.$nextTick(() => {
          const ref = this.$refs[getRefKey(optItem)];
          if (!ref || Array.isArray(ref)) return;
          const optResponse = (ref === null || ref === void 0 ? void 0 : ref.show(optItem.request)) || null;
          // 渲染弹窗并且执行show之后把Response透传出去
          optItem.responseResolve(optResponse);
        });
      }
    });
    return h("div", [renderOpt]);
  }
  show(opt) {
    const optId = this.getUniqueId(opt);
    const index = this.optList.findIndex(option => option.id === optId);
    let responsePromiseResolve;
    const responsePromise = new Promise(r => responsePromiseResolve = r);
    const newOptItem = {
      id: optId,
      request: opt,
      responseResolve: responsePromiseResolve
    };
    if (this.showedIdSet.has(optId) && index !== -1) {
      // 是重新打开 所以要先删掉 这时候期望上是替换原来的opt 然后重新走一遍show
      this.optList[index] = newOptItem;
      // 这时候是监听不到的 直接手动刷render
      this.rerenderCount += 1;
    } else {
      // 全新的窗口请求
      this.optList.push(newOptItem);
    }
    // 不在set里但是在optList的id保证触发重新渲染
    this.showedIdSet.delete(optId);
    // 关闭窗口后释放引用
    const release = async () => {
      await delay(500);
      // 如果说是重复打开一个窗口 可能引用就变了 关promise的时候要检查引用相同
      const itemToDelete = this.optList.find(item => item === newOptItem);
      if (!itemToDelete) return;
      this.showedIdSet.delete(itemToDelete.id);
      pull(this.optList, itemToDelete);
    };
    responsePromise.then(release).catch(release);
    return responsePromise;
  }
};
__decorate([Prop({
  required: true,
  type: [Object, Function]
})], UcWindowManager.prototype, "component", void 0);
__decorate([Prop({
  required: true,
  type: Function,
  default: opt => opt.id
})], UcWindowManager.prototype, "getUniqueId", void 0);
UcWindowManager = __decorate([Component({
  name: 'UcWindowManager',
  inject: {
    uc: {
      from: INJECT_UICORE_BUS
    }
  }
})], UcWindowManager);
export default UcWindowManager;
//# sourceMappingURL=UcWindowManager.js.map
